import {useQuery, useInfiniteQuery, useQueryClient, useMutation} from "react-query";
import {toast} from 'react-toastify';
import API from './utils/api';
import {
    TaxRateDto, TaxRatePaginator,
    CreateCompanyTaxRateDto, QueryTaxRateDto,
    UpdateTaxRateDto
} from "../models/tax-rate.dto";
import ENDPOINTS from "./utils/endpoints";

export function useGetCompanyTaxRate(companyId: number, options?: QueryTaxRateDto, queryOptions?: any) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RATE.GET;
    const request = API.ProcessingCompanyAPI.getCompanyTaxRate(companyId, options);

    const { data, isLoading, error, refetch } = useQuery<TaxRatePaginator, Error>(
        [url, companyId, options],
        (() => request),
        {...API.Handlers.pageParamOption, ...queryOptions}
    );

    return { data, isLoading, error, refetch };
}

export function useGetCompanyTaxRateById(companyId: number, id: number) {
    const url = ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RATE.DETAIL;
    const request = API.ProcessingCompanyAPI.getCompanyTaxRateById(companyId, id);

    const {data, isLoading, error} = useQuery<{ data:TaxRateDto }, Error>(
        [url, companyId, id],
        (() => request),
        {
            enabled: !!(id),
        }
    );

    return {
        data: data,
        isLoading,
        error,
    };
}
export function useCreateCompanyTaxRate() {
    const queryClient = useQueryClient();

    return useMutation(
        ({companyId, payload}: {companyId: number, payload: CreateCompanyTaxRateDto}) => API.ProcessingCompanyAPI.createCompanyTaxRate(companyId, payload),
        {
            onSuccess: () => {
                toast.success('Record created successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RATE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useUpdateCompanyTaxRate() {
    const queryClient = useQueryClient();

    return useMutation(
        ({payload, companyId, id}: {payload: UpdateTaxRateDto, companyId: number, id: number}) => API.ProcessingCompanyAPI.updateCompanyTaxRate(companyId, id, payload),
        {
            onSuccess: () => {
                toast.success('Record updated successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RATE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}

export function useDeleteCompanyTaxRate() {
    const queryClient = useQueryClient();

    return useMutation(
        ({ companyId, id }: { companyId: number, id: number }) => API.ProcessingCompanyAPI.deleteCompanyTaxRate(companyId, id),
        {
            onSuccess: () => {
                toast.success('Record deleted successfully');
                queryClient.invalidateQueries(ENDPOINTS.PROCESSING_COMPANY.COMPANY_TAX_RATE.GET);
            },
            onError: API.Handlers.onErrorHandler,
        }
    )
}
